import { EnumLinkTarget } from '$/(cms)/_modules/cmsService/types';

export const getTabTarget = (
  target?: EnumLinkTarget,
): '_self' | '_blank' | undefined => {
  switch (target) {
    case EnumLinkTarget.SameTab:
      return '_self';
    case EnumLinkTarget.NewTab:
      return '_blank';
    default:
      return undefined;
  }
};
